import { render } from "./Invoices.vue?vue&type=template&id=1267d9aa&scoped=true&ts=true"
import script from "./Invoices.vue?vue&type=script&lang=ts"
export * from "./Invoices.vue?vue&type=script&lang=ts"

import "./Invoices.vue?vue&type=style&index=0&id=1267d9aa&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1267d9aa"]])

export default __exports__